var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeFloatingPanel,
          expression: "closeFloatingPanel",
        },
      ],
      staticClass: "shelf-skew-picker",
    },
    [
      _c(
        "button",
        {
          ref: "trigger",
          staticClass: "shelf-skew-trigger",
          class: { "is-open": _vm.isOpen, "has-override": _vm.hasAnyOverride },
          attrs: {
            type: "button",
            title: `Shelf skew: ${_vm.formattedSkew}; product spacing: ${_vm.formattedProductSpacing}`,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleFloatingPanel.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "bi bi-arrow-clockwise" })]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "shelf-skew-panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                ref: "panel",
                staticClass: "shelf-skew-panel",
                style: _vm.floatingPanelStyle,
                attrs: { role: "dialog", "aria-label": "Shelf skew" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "shelf-skew-panel__head" }, [
                  _c("strong", [_vm._v("Shelf skew")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.formattedSkew))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-slider-wrap" }, [
                  _c("input", {
                    staticClass: "shelf-skew-slider",
                    style: _vm.sliderStyle,
                    attrs: {
                      type: "range",
                      min: _vm.min,
                      max: _vm.max,
                      step: _vm.step,
                    },
                    domProps: { value: _vm.skew },
                    on: { input: _vm.onSlider },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-panel__foot" }, [
                  _c("span", [_vm._v("Overrides fixture perspective")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { type: "button", disabled: !_vm.hasSkewOverride },
                      on: { click: _vm.inheritPerspective },
                    },
                    [_vm._v("\n          Inherit\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-panel__divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-panel__head" }, [
                  _c("strong", [_vm._v("Product spacing")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.formattedProductSpacing))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-slider-wrap" }, [
                  _c("input", {
                    staticClass: "shelf-skew-slider",
                    style: _vm.spacingSliderStyle,
                    attrs: {
                      type: "range",
                      min: _vm.spacingMin,
                      max: _vm.spacingMax,
                      step: _vm.spacingStep,
                      "aria-label": "Product spacing",
                    },
                    domProps: { value: _vm.effectiveProductSpacing },
                    on: { input: _vm.onSpacingSlider },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "shelf-skew-panel__foot" }, [
                  _c("span", [_vm._v("Overrides canvas default")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        disabled: !_vm.hasSpacingOverride,
                      },
                      on: { click: _vm.inheritProductSpacing },
                    },
                    [_vm._v("\n          Inherit\n        ")]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }